import projectOne from './assets/images/project1.png';
import projectTwo from './assets/images/project2.png';
import projectThree from './assets/images/project3.jpg';
import projectFour from './assets/images/project4.png';
import projectFive from './assets/images/project5.jpg';
import foodDraw from './assets/images/food-draw.png';
import llmTest from './assets/images/llm-test-gen.png';
import fuzzySearch from './assets/images/fuzzy-search.png';
import bandwithQoS from './assets/images/bandwidth-QoS.png';
import aboutImage from './assets/images/about3.JPG';
import { FaReact, FaPython, FaJs, FaNodeJs, FaJava, FaGraduationCap } from "react-icons/fa";
import { SiTypescript, SiNextdotjs, SiPostgresql, SiGit, SiDocker, SiVite } from "react-icons/si";

export const aboutData = {
    image: aboutImage,
    imageAlt: 'me',
    body: `Hi! I am Chrismar, a Software Engineer and first-generation university graduate from the University of California, Irvine. I recently completed my Master of Science in Computer Science after earning my Bachelor of Science.\n
           I accidentally found my way into web development in 2021 and quickly discovered a passion for creating things for the web. What started as an unexpected career path turned into a genuine love for building software and solving problems. Since then, I've worked as a Full Stack Engineer, building everything from user interfaces and backend services to cloud infrastructure and distributed systems.\n
           During my master's studies, I became especially interested in AI, particularly LLMs, and how these technologies can be applied to solve real-world software engineering problems.`,
    education: [ 
        { title: 'University of California, Irvine (December 2025)', subtitle: 'Master of Science in Computer Science', type: 'Degree', icon: < FaGraduationCap /> },
        { title: 'University of California, Irvine', subtitle: 'Bachelor of Science in Computer Science', type: 'Degree', icon: < FaGraduationCap /> },
    ],
    skills: { 
        'Next': { icon: <SiNextdotjs /> },
        'Typescript': { icon: <SiTypescript />, color: 'text-blue-700' },
        'React': { icon: <FaReact />, color: 'text-blue-500' },
        'Node': { icon: <FaNodeJs />, color: 'text-green-500' },
        'Javascript': { icon: <FaJs />, color: 'text-yellow-200' },
        'Java': { icon: <FaJava />, color: 'text-red-500' },
        'Python' : { icon: <FaPython />, color: 'text-yellow-400'},
        'SQL': { icon: <SiPostgresql />, color: 'text-blue-500' },
        'Git': { icon: <SiGit />, color: 'text-red-600' },
        'Docker': { icon: <SiDocker />, color: 'text-blue-700' },
        'Vite': { icon: <SiVite />, color: 'text-purple-700' }
    }

}

export const projectsData = [
    {
        title: 'LLM-Based Concurrency Test Generation',
        description: 'Used Large Language Models to generate concurrency-focused test cases for lock-free data structures. Evaluated the ability of LLMs to uncover race conditions, ABA problems, and atomicity violations through multithreaded stress testing.',
        github: 'https://drive.google.com/file/d/16SJEM9b6aGKtjZbeq2snAGdxct7UWNKa/view?usp=sharing',
        tags: [' C++20', 'Concurrency', 'LLMs'],
        date: 'June 2025',
        image: llmTest
    },
    {
        title: 'Distributed Wikipedia Fuzzy Search Engine',
        description: 'Built a distributed search engine capable of indexing and querying large-scale Wikipedia datasets. Developed frontend and backend services, load balancing, and distributed query execution on AWS.',
        github: 'https://drive.google.com/file/d/1iM0V1bcnAr-0vM0ICqABHmmKx0LCKT_Y/view?usp=sharing',
        tags: ['ReactJS', 'NodeJS', 'Express', 'AWS', 'EC2', 'Apache', 'Lucene'],
        date: 'March 2025',
        image: fuzzySearch
    },
    {
        title: 'ML-Based Network QoS Control',
        description: 'Explored machine learning approaches for adaptive network QoS control using Autoencoder and LSTM models. Evaluated performance under dynamic network conditions including congestion, latency, and packet loss.',
        github: 'https://drive.google.com/file/d/1iM0V1bcnAr-0vM0ICqABHmmKx0LCKT_Y/view?usp=sharing',
        tags: ['Python', 'Deep Learning', 'Networking'],
        date: 'December 2025',
        image: bandwithQoS
    },
    {
        title: 'Food Draw',
        description: 'A fun Vue 3 Application to help you and your buddies choose a great restaurant so you all can stop the fighting and start the eating.',
        github: 'https://github.com/chrismar303/food-of-luck',
        tags: ['Vue3', 'TailwindCSS', 'YelpAPI'],
        date: 'In Progress 🔨',
        image: foodDraw
    },
    { 
        title: 'COVID-19 Tracker', 
        description: 'A React Application that tracks global data pertaining to COVID-19. Also allows for country-specific inspection of data.\n', 
        link: 'https://covid-19-tracker-e0dc2.firebaseapp.com/',
        tags: ['React', 'CovidAPI', 'NewsAPI'],
        date: 'September 2020',
        image: projectOne 
    },
    { 
        title: 'FOODAR', 
        description: 'A NodeJS Fullstack Application that tracks a user’s list of establishments or restaurants the user would like to visit. When the logs in, establishments are listed in the order of closest proximity', 
        link: 'https://hidden-retreat-20671.herokuapp.com/',
        tags: ['NodeJs', 'EJS', 'TailwindCSS', 'HTML', 'CSS3', 'Mongoose', 'PassportJS', 'YelpAPI'],
        date: 'August 2020',
        image: projectTwo 
    },
    { 
        title: 'Stock ROI Projector', 
        description: 'A Python program that calculates the user’s Return On Investment (ROI) based on the user’s selected time interval and growth expectations.', 
        github: 'https://github.com/chrismar303/stock_projector',
        tags: ['Python'],
        date: 'October 2021',
        image: projectThree 
    },
    { 
        title: 'Class Tracker', 
        description: 'A Python program that uses the selenium library to automate the process of checking a class’ availability status.', 
        github: 'https://github.com/chrismar303/mtsac-class-tracker',
        tags: ['Python', 'BeautifulSoup', 'Selenium'],
        date: 'November 2021',
        image: projectFour 
    },
    { 
        title: 'Movie Showtimes Link Scraper', 
        description: 'A Python program that automates the process of finding all AMC movie showtimes based on a given zip code. Ticket purchase links and showtimes are saved onto a local file.', 
        github: 'https://github.com/chrismar303/movie_showtimes_scraper',
        tags: ['Python', 'Selenium'],
        date: 'September 2020',
        image: projectFive 
    },
]

export const personalData = {
    phone: '1 (626) 460-0121',
    email: 'Chrismar303.dev@gmail.com',
    location: 'Los Angeles & Orange Country Area',
    resume: 'https://drive.google.com/file/d/1VoTZrf4noZ38qg5kIsGfK5bupEwfh_se/view?usp=sharing'
}